import { PrintCardMenu } from './print-card-menu';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';

export class TrueNorthPortraitPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Gilroy.SemiBold_600,
      FONT.Gilroy.ExtraBold_800,
      FONT.Montserrat.Medium_500,
      FONT.Montserrat.SemiBold_600,
      FONT.Montserrat.Bold_700,
      FONT.Montserrat.ExtraBold_800
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/buf2vss.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
